"use strict";

import axios from "axios";
import router from "../router"
import store from "../store"
// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

let config = {
  // baseURL: process.env.baseURL || process.env.apiUrl || ""
  timeout: 60 * 1000 // Timeout
  // withCredentials: true, // Check cross-site Access-Control
};

const vxios = axios.create(config);

vxios.interceptors.request.use(
  function(config) {
    config.baseURL = process.env.VUE_APP_VIDEO_URL;
    config.headers.Authorization = localStorage.getItem("api_token");
    return config;
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
vxios.interceptors.response.use(
  function(response) {
    if (response.data.code !== 200) {
      const message = response.data.message || "操作失败";
      throw Error(message);
    }
    return response.data;
  },
  function(error) {
    const res = JSON.parse(JSON.stringify(error)).response
    if(res.status == 4101){
      store.dispatch("logout").then(() => {
        router.replace({ name: "home" });
        router.go(0)
      });
    }
    // Do something with response error
    return Promise.reject(error);
  }
);

export default vxios;
